const Parallax = require('simple-parallax-js');

function isInViewport(el) {
    let top = el.offsetTop;
    let left = el.offsetLeft;
    let width = el.offsetWidth;
    let height = el.offsetHeight;

    while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
}

function throttle(func, timeFrame) {
    let lastTime = 0;
    return function () {
        let now = Date.now();
        if (now - lastTime >= timeFrame) {
            func();
            lastTime = now;
        }
    };
}

function bindAnimations(elementOfClass, toAddClass) {
    for (const element of document.querySelectorAll('.' + elementOfClass)) {
        if (isInViewport(element)) {
            element.classList.add(toAddClass);
        }

        document.addEventListener('scroll', throttle(() => {
            if (!element.classList.contains(toAddClass) && isInViewport(element)) {
                element.classList.add(toAddClass);
            }
        }, 100));
    }
}

export default function initAnimations() {
    bindAnimations('image-block', 'image-block-active');
    bindAnimations('floating-image-block', 'floating-image-block-active');
    bindAnimations('background-image-block', 'background-image-block-active');
    bindAnimations('background-image-block', 'background-image-block-active');

    new Parallax(document.querySelectorAll('.paralax'), {
        scale: 1.5
    });
}
